module.exports = __webpack_public_path__ + "img/print-text.f27a5577.svg";